import { type PageChangeSummary, type PublicationSummary } from "api/api-types-publishing";

export const splitSummaryBySubmissions = (
  summary: PublicationSummary,
  pageIdsWithLinkedSubmissions: ReadonlySet<string>,
): { filteredSummary: PublicationSummary; pagesWithSubmissions: PageChangeSummary[] } => {
  const hasSubmissions = (page: PageChangeSummary) => pageIdsWithLinkedSubmissions.has(page.id);

  const allPages = [
    ...summary.topics.flatMap((t) => [
      ...t.prep_pages,
      ...t.lesson_pages,
      ...t.resource_pages,
      ...t.archive_pages,
    ]),
    ...summary.assignments,
    ...summary.resources,
    ...summary.workspaces,
  ];

  const exclude = (pages: PageChangeSummary[]) => pages.filter((p) => !hasSubmissions(p));

  return {
    filteredSummary: {
      ...summary,
      topics: summary.topics.map((topic) => ({
        ...topic,
        prep_pages: exclude(topic.prep_pages),
        lesson_pages: exclude(topic.lesson_pages),
        resource_pages: exclude(topic.resource_pages),
        archive_pages: exclude(topic.archive_pages),
      })),
      assignments: exclude(summary.assignments),
      resources: exclude(summary.resources),
      workspaces: exclude(summary.workspaces),
    },
    pagesWithSubmissions: allPages.filter(hasSubmissions),
  };
};
